import {createStore} from "redux";
let data={
    power:{}
}
const reducer=(state=data,action)=>{
    switch(action.type){
        case 'POWER':
            return {power:action.data}
        break
    }
}
const store = createStore(reducer);
export default store